import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { DuoActionDialogModel } from '../../../interfaces/dialogs/duo-action-dialog.model';
import { MatButton } from '@angular/material/button';

/**
 * 雙按鈕通用dialog組件，對應樣式C
 */
@Component({
  selector: 'app-duo-action-dialog',
  standalone: true,
  imports: [MatButton, MatDialogContent],
  templateUrl: './duo-action-dialog.component.html',
  styleUrl: './duo-action-dialog.component.scss',
})
export class DuoActionDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DuoActionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DuoActionDialogModel
  ) {}
  close() {
    this.dialogRef.close();
  }

  onLeftButtonClick(): void {
    if (this.data.leftButtonAction) {
      this.data.leftButtonAction();
    }
    this.close();
  }

  onRightButtonClick(): void {
    if (this.data.rightButtonAction) {
      this.data.rightButtonAction();
    }
    this.close();
  }
}
